/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Boxing_TermsInputs */

const en_service_type_boxing_terms = /** @type {(inputs: Service_Type_Boxing_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`boxing, kickboxing, pads, boxing coach`)
};

const pl_service_type_boxing_terms = /** @type {(inputs: Service_Type_Boxing_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`boks, kickboxing, trening bokserski, tarcze, worek`)
};

/**
* | output |
* | --- |
* | "boxing, kickboxing, pads, boxing coach" |
*
* @param {Service_Type_Boxing_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_boxing_terms = /** @type {((inputs?: Service_Type_Boxing_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Boxing_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_boxing_terms(inputs)
	return en_service_type_boxing_terms(inputs)
});